import { ChampPersonnaliseType } from '../../app.constants';

export enum EtapeChampCompteRendu {
  PRISE_DE_SERVICE = 'PRISE_DE_SERVICE',
  ARRIVEE_SUR_SITE = 'ARRIVEE_SUR_SITE',
  ACCES_AU_SITE = 'ACCES_AU_SITE',
  COMPTE_RENDU = 'COMPTE_RENDU',
  FIN_DE_SERVICE = 'FIN_DE_SERVICE',
  CLOTURE = 'CLOTURE',
}

export class ChampCompteRendu {
  constructor(
    public id: string,
    public libelle: string,
    public type: ChampPersonnaliseType,
    public etape: EtapeChampCompteRendu,
    public required: boolean,
    public choix: string[] = [],
    public boutonPlus?: string,
    public valeur?: any,
    public groupe?: string,
    public reference?: string
  ) {}

  public static hydrate(champ: ChampCompteRendu): ChampCompteRendu {
    return new ChampCompteRendu(
      champ.id,
      champ.libelle,
      champ.type,
      champ.etape,
      champ.required,
      champ.choix,
      champ.boutonPlus,
      champ.valeur,
      champ.groupe,
      champ.reference
    );
  }

  public isChampCompteRenduFacultatifOuRemplis(): boolean {
    return !this.required || this.isChampCompteRenduRemplis();
  }

  public isChampCompteRenduRemplis(): boolean {
    switch (this.type) {
      case ChampPersonnaliseType.STRING:
      case ChampPersonnaliseType.STRING_MULTILINE:
      case ChampPersonnaliseType.INT:
      case ChampPersonnaliseType.DOUBLE:
      case ChampPersonnaliseType.RADIO_LIST:
        return this.valeur && this.valeur.toString().length > 0;
      case ChampPersonnaliseType.BOOLEAN:
        return typeof this.valeur === 'boolean' || this.valeur === 'true' || this.valeur === 'false';
      case ChampPersonnaliseType.TOGGLE:
        return this.valeur !== null && this.valeur !== undefined && this.valeur !== '';

      case ChampPersonnaliseType.STRING_ARRAY:
      case ChampPersonnaliseType.CHECKBOX_LIST:
        return this.valeur && Array.isArray(this.valeur) && this.valeur.length > 0;

      default:
        throw new Error(`Type de champ inconnu: ${this.type}`);
    }
  }
}
